__turbopack_context__.v({
  "app_light_theme": "FormSuccessMessage-module-scss-module__J5xO4q__app_light_theme",
  "buttonClose": "FormSuccessMessage-module-scss-module__J5xO4q__buttonClose",
  "formSuccessMessage": "FormSuccessMessage-module-scss-module__J5xO4q__formSuccessMessage",
  "iconWrap": "FormSuccessMessage-module-scss-module__J5xO4q__iconWrap",
  "subtitle": "FormSuccessMessage-module-scss-module__J5xO4q__subtitle",
  "title": "FormSuccessMessage-module-scss-module__J5xO4q__title",
});
